import React, { memo } from 'react';

import { CurrentConditionsBodyContainer } from './styledComponents/currentConditionsBodyContainer';
import { CurrentConditionsObsWrapper } from './currentConditionsObsWrapper';
import { CurrentConditionsSummaryWrapper } from './currentConditionsSummaryWrapper';

export const CurrentConditionsBodyView = memo(() => {
    return (
        <CurrentConditionsBodyContainer >
            <CurrentConditionsObsWrapper />
            <CurrentConditionsSummaryWrapper />
        </CurrentConditionsBodyContainer>
    );
});

CurrentConditionsBodyView.displayName = 'CurrentConditionsBody';

